import Api from "@/lib/axios";

const AdminService = {
  getUserInfo() {
    return Api.get("/api/autopricing/users/me");
  },
  notifyAboutDeviationsBetweenDashboards(params) {
    return Api.post("/api/autopricing/notification/difference-in-dest-countries-config", params);
  },
  notifyEndUserRatesDeviateFromMarketRates(params) {
    return Api.post("/api/autopricing/notification/deviated-end-rate-from-market", params);
  },
  notifyAboutExistingSetOfManualRates(params) {
    return Api.post("/api/autopricing/notification/existing-manual-rates", params);
  },
  notifyWhenCorridorsAreMissing(params) {
    return Api.post("/api/autopricing/notification/missing-corridors", params);
  },
  notifyAboutSummaries(params) {
    return Api.post("/api/autopricing/notification/summaries", params);
  },
  notifyAboutProviderRateDeviations(params) {
    return Api.post("/api/autopricing/notification/provider-rate-deviation", params);
  },
  runProviderRatesETL() {
    return Api.post("/api/autopricing/admin/partners/payout/etl");
  },
  getSyncedPayoutConfigs(middleware) {
    return Api.get("/api/autopricing/synced-payout-configs", {
      params: middleware ? { middleware } : {}
    });
  },
  resyncPayoutConfigs(middleware) {
    return Api.post("/api/autopricing/synced-payout-configs/resync", null, {
      params: middleware ? { middleware } : {}
    });
  },
  syncSendingCurrencies() {
    return Api.post("/api/autopricing/admin/partners/payout/sending-currency-sync", null, { tenant: true });
  },
  getDahabshiilBranchRateConfigs() {
    return Api.get("/api/autopricing/admin/partners/payout/dahabshiil/branch-rate-configs");
  },
  validateDahabshiilBranchCode(params) {
    return Api.post("/api/autopricing/admin/partners/payout/dahabshiil/branch-rate-configs/validate", params);
  },
  createDahabshiilBranchRateConfig(params) {
    return Api.post("/api/autopricing/admin/partners/payout/dahabshiil/branch-rate-configs", params);
  },
  updateDahabshiilBranchRateConfig(id, params) {
    return Api.put(`/api/autopricing/admin/partners/payout/dahabshiil/branch-rate-configs/${id}`, params);
  },
  deleteDahabshiilBranchRateConfig(id) {
    return Api.delete(`/api/autopricing/admin/partners/payout/dahabshiil/branch-rate-configs/${id}`);
  },
  getRemitfinderSettings() {
    return Api.get("/api/autopricing/admin/remitfinder/settings");
  },
  updateRemitfinderSettings(instance, params) {
    return Api.put(`/api/autopricing/admin/remitfinder/settings/${instance}`, params);
  }
};

export default AdminService;
